<template>
  <div class="d-flex justify-center mb-6">
    <div
      v-if="wholePageLoad"
      class="d-flex h-100 justify-center align-items-center"
      style="min-height:50vh;"
    >
      <v-progress-circular
        indeterminate
        color="black"
        size="50"
      ></v-progress-circular>
    </div>
    <v-card v-else elevation="0" style="width: 98%; max-width: 1000px;">
      <v-btn class="ma-2" outlined @click="goBack">
        <span style="font-size: 1.2rem" class="ml-2 mb-1">
          رجوع
        </span>
        <v-icon>mdi-backburger</v-icon>
      </v-btn>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          v-model="fields.name"
          :rules="nameRules"
          label="التسمية"
          required
        ></v-text-field>

        <v-text-field
          v-model="fields.query"
          :rules="queryRules"
          label="استفسار"
          required
        ></v-text-field>

        <v-autocomplete
          v-model="selectedUser"
          chips
          :items="items"
          :loading="isLoading"
          :search-input.sync="search"
          clearable
          hide-details
          hide-selected
          item-text="firstName"
          item-value="id"
          label="ابحث هنا"
          class="mb-5"
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title
                v-text="item.firstName + ' ' + item.lastName"
              ></v-list-item-title>
              <v-list-item-subtitle v-text="item.email"> </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>

        <v-btn class="mr-4" @click="goBack" depressed outlined large>
          <span style="font-size: 1.2rem" class="ml-2 mt-1">
            إلغاء
          </span>
          <v-icon>cancel</v-icon>
        </v-btn>

        <v-btn
          :disabled="!valid"
          class="mr-4"
          @click="submit"
          depressed
          outlined
          large
        >
          <span style="font-size: 1.2rem" class="ml-2 mt-1">
            حفظ
          </span>
          <v-icon>save</v-icon>
        </v-btn>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { searchUser, getUserData } from "@services/User.api";
export default {
  data: () => ({
    fields: { name: "", query: "", userId: 0 },
    valid: true,
    nameRules: [(v) => !!v || "Name is required"],
    queryRules: [(v) => !!v || "Query is required"],
    isLoading: false,
    items: [],

    selectedUser: null,
    search: null,
    wholePageLoad: true,
  }),

  methods: {
    ...mapActions("userQueries", ["getUserQuery", "updateUserQuery"]),
    submit() {
      const { id } = this.$route.params;

      this.fields.userId = this.selectedUser.id
        ? this.selectedUser.id
        : this.selectedUser;

      this.$confirm({
        message: `هل أنت متأكد(ة)؟ لا يمكن التراجع عن هذه الخطوة`,
        button: {
          no: "لا",
          yes: "نعم",
        },
        callback: (confirm) => {
          if (confirm) {
            this.wholePageLoad = true;

            this.updateUserQuery({ id, ...this.fields }).then(() => {
              // this.$router.push({ name: "BackendUserQuery" });
              this.wholePageLoad = false;
            });
          }
        },
      });
    },
    goBack() {
      this.$router.push({ name: "BackendUserQuery" });
    },
  },
  mounted() {
    const { id } = this.$route.params;

    this.getUserQuery(id).then(({ name, query, userId }) => {
      this.fields.name = name;
      this.fields.query = query;

      getUserData(userId).then((res) => {
        this.selectedUser = res.data.payload.user;
        this.items.push({ ...res.data.payload.user });

        this.wholePageLoad = false;
      });
    });
  },
  watch: {
    search(val) {
      if (!val) return;

      this.isLoading = true;

      searchUser(val)
        .then((res) => {
          this.items = res.data.payload;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>
